// extracted by mini-css-extract-plugin
export default {"page-wrapper":"_5D334Omh"};